<script lang="ts">
	import { createPromiseStore } from "../../../../core/utils/createPromiseStore.js";
	import type { ContactFormInput } from "../../../../core/schema/ContactForm.js";
	import sendContactForm from "../../api/mutations/sendContactForm.graphql";
	import ContactFields from "../Form/ContactFields.svelte";
	import FormFooter from "../Form/FormFooter.svelte";
	import Button from "../Button.svelte";
	import Modal from "../Modal.svelte";
	import Form from "../Form/Form.svelte";
	import { mutation } from "../../api/graphql.js";
	import translations from "./ContactForm.translations.json";
	import { ContactFormType } from "../../../../core/schema/ContactFormType.js";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import { getTenant } from "../../getTenant.js";
	import { readContactFormData } from "../Form/readContactFormData.js";

	export let id: string | undefined = undefined;
	export let containerClass = "mx-4 md:mx-16 lg:mx-32";
	const translate = getTranslate(translations);

	const { PUBLIC_GRAPHQL_ENDPOINT } = getGlobalSettings();

	const tenant = getTenant();

	const send = createPromiseStore(async (input: ContactFormInput) => {
		await mutation<boolean>(PUBLIC_GRAPHQL_ENDPOINT, sendContactForm, { input });
	});

	let showSuccessModal = false;
	async function submit(event: CustomEvent<SubmitEvent>): Promise<void> {
		const form = event.detail.target as HTMLFormElement;
		const input: ContactFormInput = {
			...readContactFormData(new FormData(form), tenant.locale),
			type: ContactFormType.Contact,
		};
		await send.call(input);
		form.reset();
		showSuccessModal = true;
	}
</script>

<Modal show={showSuccessModal}>
	<p class="h2" slot="title">{translate("thanks")}</p>
	<div class="flex flex-col items-center gap-2">
		<p>{translate("willBeInTouch")}</p>

		<Button
			on:click={() => {
				showSuccessModal = false;
			}}
		>
			{translate("understand")}
		</Button>
	</div>
</Modal>

<div class="border-lttertiary border-y">
	<div class="mx-auto max-w-[120rem]">
		<div class="{containerClass} flex flex-col xl:grid xl:grid-cols-2" id="contact-form">
			<div class="border-lttertiary border-x px-2 py-5 md:p-8 xl:border-r-0">
				<h2 class="text-ltprimary mx-auto mb-4 text-center uppercase tracking-wider md:text-left lg:mx-[initial]">
					{translate("title")}
				</h2>
				<p class="lg:!text-md/normal mx-auto max-w-2xl text-black lg:mx-[initial]">
					{translate("desc")}
				</p>
			</div>
			<Form class="border-lttertiary border-x" on:submit={submit} {id}>
				<ContactFields nameClass="border-y xl:border-t-0" />
				<FormFooter
					loading={$send.status === "loading"}
					error={$send.status === "error"}
					errorClass="mx-2 mb-4 md:mx-4 xl:mx-8"
					disclaimerClass="mx-2 mb-6 md:mx-4 xl:mx-8"
				/>
			</Form>
		</div>
	</div>
</div>
